"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GhostSlider = exports.StyledContainer = exports.StyledCarouselWrapper = exports.StylePaginationBarWrapper = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
exports.StylePaginationBarWrapper = components_core_1.styled.div `
  width: 100%;
  padding-bottom: 4px;

  @media (min-width: ${components_core_1.Breakpoints.b560}px) {
    ${(props) => props.showBorder ? `border-bottom: solid 1px ` : ''}
    ${(props) => props.theme.colors.border.default};
    ${(props) => props.showBorder ? `padding-bottom: 8px` : ''};
  }
`;
exports.StyledCarouselWrapper = components_core_1.styled.div `
  min-width: -moz-available;
  min-width: -webkit-fill-available;

  @media (min-width: ${components_core_1.Breakpoints.b560}px) {
    ${(props) => props.hideMargin ? 'margin-right: 0px;' : 'margin-right: -150px;'};
  }

  .slick-slide,
  .slick-slide * {
    outline: none !important;
  }

  .slick-track {
    display: flex !important;
  }

  .slick-slide {
    display: flex !important;
    height: auto !important;
  }
`;
exports.StyledContainer = components_core_1.styled.div `
  height: 100%;
  @media (min-width: ${components_core_1.Breakpoints.b560}px) {
    ${(props) => props.hideMargin ? 'padding-right: 0px;' : 'padding-right: 40px;'};
  }
`;
exports.GhostSlider = components_core_1.styled.div `
  width: 100%;
  height: 100%;
`;
